import styled from 'styled-components'
import { TextStyles, defaultSectionTheme } from '@/constants'
import Typography from '@/components/Typography'

export const StatisticTitle = styled(Typography).attrs({
  variant: TextStyles['Large Display Font'],
})`
  color: ${({ theme }) =>
    theme.pageTheme?.main ||
    theme.sectionTheme?.text ||
    defaultSectionTheme.text};
  word-break: break-word;
  min-width: 134px;
  margin-bottom: 5px;

  ${({ theme }) => theme.mediaBreakpointUp.md} {
    margin-bottom: 10px;
  }
`

export const StatisticDescription = styled(Typography).attrs({
  variant: TextStyles['Large Paragraph Text'],
})`
  color: ${({ theme }) => theme.sectionTheme?.lightSubText || defaultSectionTheme.lightSubText};
  word-break: break-word;
`
